    /// <reference path="onlineBookingSettings.module.ts" />
/// <reference path="../../components/common/businessinfo.service.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.OnlineBookingSettings {
    class OnlineBookingSettingsController extends Meevo.Components.CommonClasses.CommonControllerBase {
        // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate",
            "$q"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.Common.BusinessInfoDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: ng.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();
        }

        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS).then(() => {
                vm.busyService.stop();
                vm.context = new OnlineBookingSettingsContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, this.trackingService, vm.$translate, vm.$scope, vm.$q, vm.contextParams);
                super.createContext();

                vm.context.postUpdate = (model: any) => {
                    this.$rootScope.$broadcast("updateRegisterSetting", { enableIntegratedRegister: model.enableIntegratedRegister });
                    if (Model.Guard.isSomething(this.context.closeCallback))
                        this.context.closeCallback(model, true);
                }
            });
        }
    }

    angular.module("meevo.plugins.onlineBookingSettings")
        .controller("meevo.plugins.onlineBookingSettings.OnlineBookingSettingsController", OnlineBookingSettingsController);
}